"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssVars = void 0;
exports.cssVars = {
    backgroundColor: 'background-color',
    borderColor: 'border-color',
    borderRadius: 'border-radius',
    borderWidth: 'border-width',
    foregroundColor: 'foreground-color',
    textColor: 'color',
};
//# sourceMappingURL=constants.js.map